import React from 'react';
import './ProductDetailsSoldOutLabel.scss';

interface Props {
  available: boolean;
}

export const ProductDetailsSoldOutLabel: React.FC<Props> = ({ available }) => {
  if (available) return null;

  return <div className="ProductDetailsSoldOutLabel">Sold Out</div>;
};
